module.exports = __webpack_public_path__ + "static/media/Inter-Medium.3a88989d.woff";